export default __webpack_public_path__ + "static/media/gilbertolara.36707842.png";